import { render, staticRenderFns } from "./M-support.vue?vue&type=template&id=6a433f96&scoped=true&"
import script from "./M-support.vue?vue&type=script&lang=js&"
export * from "./M-support.vue?vue&type=script&lang=js&"
import style0 from "./M-support.vue?vue&type=style&index=0&id=6a433f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a433f96",
  null
  
)

export default component.exports